export default __webpack_public_path__ + "static/media/features-home-element-03.60169bca.png";